<template>
  <v-app>
    <PayHeader />
    <v-main>
      <v-content>
        <v-container v-show="!storage.overlay" fill-height class="v-container">
          <router-view></router-view>
        </v-container>
        <v-container v-show="storage.overlay" fill-height class="v-container">
          <v-layout style="display: flex; min-height: 500px;">
            <v-row
              justify="center"
              align="center"
            >
              <v-progress-circular
                :size="100"
                :width="10"
                color="green"
                indeterminate
              />
            </v-row>
          </v-layout>
        </v-container>
      </v-content>
    </v-main>
    <PayFooter />
  </v-app>
</template>

<script>
import PayHeader from '@/components/PayHeader.vue'
import PayFooter from '@/components/PayFooter.vue'
import { provide, reactive, ref } from 'vue'
import router from '@/utils/router'

export default {
  name: 'PayApp',

  components: {
    PayHeader: PayHeader,
    PayFooter: PayFooter
  },
  setup () {
    const storage = reactive({
      overlay: ref(true),
      showBack: ref(false)
    })

    const setStorage = (key, val) => {
      if (val instanceof Object) {
        storage[key] = val
      } else {
        storage[key] = ref(val)
      }
    }

    const vouchersQuantity = () => {
      const quantity = Math.floor(Number(storage.number_of_vouchers))
      return quantity > 0 ? quantity : 1
    }

    const actualize = () => {
      storage.amount = storage.provider.limits.min * vouchersQuantity()
    }

    const increase = () => {
      storage.number_of_vouchers = vouchersQuantity() + 1
      actualize()
    }

    const decrease = () => {
      storage.number_of_vouchers = Math.max(1, vouchersQuantity() - 1)
      actualize()
    }

    const normalize = () => {
      storage.number_of_vouchers = vouchersQuantity()
      actualize()
    }

    const actualizeAmountTo = () => {
      const ranges = Object.values(storage.provider.ranges)
        .sort((a, b) => a.min_amount - b.min_amount)

      if (storage.amount === '') {
        storage.amount_to = ''
        return
      }

      for (let i = 0; i < ranges.length; i++) {
        const current = ranges[i]
        const next = ranges[i + 1]

        const lowerBound = current.min_amount
        const upperBound = next ? next.min_amount : Infinity

        if (storage.amount >= lowerBound && storage.amount < upperBound) {
          storage.amount_to = Math.floor(storage.amount * current.rate * 1e6) / 1e6

          break
        }
      }
    }

    const prevHistory = () => {
      if (router.currentRoute.value.path.includes('/pay/') && storage.provider.type_id === 2) {
        storage.amount = 0
      }
      router.go(-1)
      if (router.currentRoute.value.path.includes('/provider/')) {
        router.push('/')
      }
    }

    const setToRoute = (Route) => {
      if (router.currentRoute.value.path !== '/') {
        setStorage('overlay', true)
        router.push({ name: Route })
      }
    }

    provide('storage', { storage, setStorage })
    provide('history', { prevHistory, setToRoute })
    provide('voucher', { increase, actualize, decrease, normalize })
    provide('crypto', { actualizeAmountTo })

    return {
      storage
    }
  }
}
</script>
